import HttpClientToken from '../../services/HttpClientToken';

import { defaultSentidoSentencia, SentidoSentenciaProps } from '../../interfaces/catalogos/SentidoSentenciaInterface';

export const SentidoSentencia = () => {

    return new Promise<SentidoSentenciaProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/SentidoSentencia/', token)
            .then( ({ data } : { data : SentidoSentenciaProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerSentidoSentencia = () => {

    return new Promise<SentidoSentenciaProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/SentidoSentencia/ObtenerSentidoSentencia', token)
            .then( ({ data } : { data : SentidoSentenciaProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarSentidoSentencia = ( params: SentidoSentenciaProps ) => {

    return new Promise<SentidoSentenciaProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/SentidoSentencia/Actualizar', params, token)
            .then( ({ data } : { data : SentidoSentenciaProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultSentidoSentencia } );
            });

        }

    });

}

export const AgregarSentidoSentencia = ( params: SentidoSentenciaProps ) => {

    return new Promise<SentidoSentenciaProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/SentidoSentencia/Agregar', params, token)
            .then( ({ data } : { data : SentidoSentenciaProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultSentidoSentencia } );
            });

        }

    });

}
